module.exports = "https://static.wmbcdn.com/uniweb/images/5cecf4dd1628f97652d40b591f3d1837.svg";